import { useTranslation } from "react-i18next";


const Logo = ({height, withNavigation =false,width}) => {

    const { i18n } = useTranslation();

    const ArLogo = () => !!withNavigation?(
        <div
        style={{
            width: width??70,
            maxHeight:  height && height>0?height:180,
         
        }}
         >
        <img
            src={require('../assets/whizz-app-logos/logoN3.png')}
            style={{
                width: width??70,
                maxHeight:  height && height>0?height:180,
                alignSelf: 'center',
                resizeMode:'contain'
            }}
        />
        </div>
        
    ):(
        <img
            src={require('../assets/whizz-app-logos/logoN3.png')}
            style={{
                width: width??70,
                maxHeight:  height && height>0?height:180,
                alignSelf: 'center',
                resizeMode:'contain'
            }}
        />
    )
    const EnLogo = () =>!!withNavigation? (
        <div
        style={{
            width:width?? 70,
            maxHeight:  height && height>0?height:180,
         
        }}
       >
        <img
            src={require('../assets/whizz-app-logos/logoN3.png')}
        
            style={{
                width: width??70,
                maxHeight: height && height>0?height:180,
                alignSelf: 'center',
                resizeMode:'contain'
            }}
        />
         </div>
    ):(
        <img
            src={require('../assets/whizz-app-logos/logoN3.png')}
            style={{
                width: width??70,
                maxHeight: height && height>0?height:180,
                alignSelf: 'center',
                resizeMode:'contain'
            }}
        />
    )
    return (
        <>
            {
                i18n.language == 'ar' ? <ArLogo /> : <EnLogo />
            }
        </>
    )
}

export default Logo
